const VIDEO_AUTOPLAY_DATA_ATTR = 'data-video-autoplay-control';
const VIDEO_AUTOPLAY_DATA_TARGET_ATTR = 'data-video-autoplay-control-target';
const VIDEO_AUTOPLAY_STATUS_DATA_ATTR = 'data-video-autoplay-status';

const VIDEO_AUTOPLAY_STATUSES = {
  LOADING: 'loading',
  PAUSE: 'pause',
  PLAY: 'play',
};

export const initVideoAutoplayControls = () => {
  const videoRelatedControls = document.querySelectorAll(
    `button[${VIDEO_AUTOPLAY_DATA_ATTR}]`
  );

  videoRelatedControls.forEach((videoControl) => {
    videoControl.setAttribute(
      VIDEO_AUTOPLAY_STATUS_DATA_ATTR,
      VIDEO_AUTOPLAY_STATUSES.LOADING
    );

    const autoplayControlValue = videoControl.getAttribute(
      VIDEO_AUTOPLAY_DATA_ATTR
    );

    const relatedVideos = document.querySelectorAll(
      `video[${VIDEO_AUTOPLAY_DATA_TARGET_ATTR}=${autoplayControlValue}]`
    );

    if (relatedVideos.length > 0) {
      videoControl.addEventListener('click', () => {
        relatedVideos.forEach((videoEl) => {
          syncVideoControlActionWithVideo(videoControl, videoEl);
        });
      });

      relatedVideos.forEach((videoEl) => {
        syncVideoWithVideoControls(videoEl, videoControl);
      });
    }
  });
};

function syncVideoWithVideoControls(videoEl, videoControl) {
  videoEl.addEventListener('loadeddata', () => {
    videoControl.setAttribute(
      VIDEO_AUTOPLAY_STATUS_DATA_ATTR,
      VIDEO_AUTOPLAY_STATUSES.PAUSE
    );
  });

  const playPromise = videoEl.play();

  if (videoEl && playPromise !== undefined) {
    playPromise
      .then(() => {
        videoControl.setAttribute(
          VIDEO_AUTOPLAY_STATUS_DATA_ATTR,
          VIDEO_AUTOPLAY_STATUSES.PLAY
        );
      })
      .catch(() => {
        videoEl.pause();
        videoControl.setAttribute(
          VIDEO_AUTOPLAY_STATUS_DATA_ATTR,
          VIDEO_AUTOPLAY_STATUSES.PAUSE
        );
      });
  }
}

function syncVideoControlActionWithVideo(videoControl, videoEl = []) {
  if (videoEl.paused || videoEl.ended) {
    videoEl
      .play()
      .then(() =>
        videoControl.setAttribute(
          VIDEO_AUTOPLAY_STATUS_DATA_ATTR,
          VIDEO_AUTOPLAY_STATUSES.PLAY
        )
      )
      .catch(() =>
        videoControl.setAttribute(
          VIDEO_AUTOPLAY_STATUS_DATA_ATTR,
          VIDEO_AUTOPLAY_STATUSES.PAUSE
        )
      );
  } else {
    videoEl.pause();
    videoControl.setAttribute(
      VIDEO_AUTOPLAY_STATUS_DATA_ATTR,
      VIDEO_AUTOPLAY_STATUSES.PAUSE
    );
  }
}
